import { RouteKeys } from "../constants/route";
import { pathOr } from "ramda";
import Store from "../reducers";
import { SiderPath, AttrRouteFormat, SiderRouteFormat } from "../constants/route";
import { MenuType } from "../components/layout/Menu";
import SiderRoute from "../constants/siderRoute";
import OrgUtil, { Roles } from "./organize";
import I18n, { fromIndex } from "../i18n";
import siderRoute from "../constants/siderRoute";




export default {
	/**
     * Check user can to this route
		 * */
	 CheckRoutePermission(defaultPermission = true) {
		const getRoles = pathOr([],["user", "user", "roles"],Store.getState());
		const checkSuperAdmin = getRoles.find(item => item === Roles.SuperAdmin);
		const { routePermission } = Store.getState().organization;
		const routeKey = pathOr("",["pathname"],window.location).substring(1).toUpperCase();
		return checkSuperAdmin ? true: pathOr(defaultPermission,[routeKey],routePermission);
	},
	/**
	 * 
     * Create category route key
     * @param {object} categoryInfo 
     * @param {string} attrFormat
     */
	CreateCategoryRouteKey(categoryInfo, attrFormat){
		return this.CreateCategoryRouteKeyByName(categoryInfo.name, attrFormat);
	},
	/**
     * Create category route key by name
     * @param {string} category_name
     * @param {string} attrFormat
     */
	CreateCategoryRouteKeyByName(category_name, attrFormat){
		return fromIndex(attrFormat, category_name.toLowerCase());
	},
	/**
     * Create sider path for category
     * @param {object} categoryInfo 
     * @param {string} siderFormat
     * @param {string} attrFormat
     */
	CreateCategorySiderRoute(categoryInfo, siderFormat, attrFormat){
		return fromIndex(siderFormat, this.CreateCategoryRouteKey(categoryInfo, attrFormat));
	},
	/** 
     * Create sider route path which include dynamic report attribute.
    */
	CreateSiderPaths(){
		const infos = OrgUtil.getAllCategoryInfoFromState(Store.getState());
		let builded = {...SiderPath};
		const mapping = [
			{ attr:AttrRouteFormat.STRESS, sider: SiderRouteFormat.STRESS },
			{ attr:AttrRouteFormat.COUNSELING, sider: SiderRouteFormat.COUNSELING },
		];
		infos.forEach((v)=>{
			mapping.forEach(m=>{
				const { attr, sider } = m;
				builded[this.CreateCategoryRouteKey(v, attr)] = 
                    this.CreateCategorySiderRoute(v, sider, attr);
			});
		});
		return builded;
	},
	/** 
     * Create sider route which include dynamic report attribute
    */
	CreateSiderRoutes(){
		// console.log('oriSiderRoute: ',SiderRoute);
		let siderRoutes = this._copySiderRoute(SiderRoute);
		siderRoutes = this._createStressSiderRoute(siderRoutes);
		siderRoutes = this._createCounselingSiderRoute(siderRoutes);
		return siderRoutes;
	},
	_createStressSiderRoute(siderRoutes){
		const reportIndexs = this._getRouteIterateIndex(siderRoute, 
			[RouteKeys.REPORT, RouteKeys.TEST, RouteKeys.STRESS_TEST]);
		const reportSubmenu = siderRoutes[reportIndexs[0]]
			.submenu[reportIndexs[1]]
			.submenu[reportIndexs[2]]
			.submenu;
		const catInfos = OrgUtil.getAllCategoryInfoFromState(Store.getState());
		const viewByFormat = I18n.t("siderTap.view_by");
		catInfos.forEach(info => {
			reportSubmenu.push({
				text: viewByFormat.replace("%s",info.name),
				key: this.CreateCategoryRouteKey(info, AttrRouteFormat.STRESS),
				menuType: MenuType.ITEM
			});
		});
		siderRoutes[reportIndexs[0]]
			.submenu[reportIndexs[1]]
			.submenu[reportIndexs[2]].submenu = reportSubmenu;
		return siderRoutes;
	},
	_createCounselingSiderRoute(siderRoutes){
		const counselingIndexs = this._getRouteIterateIndex(siderRoute, 
			[RouteKeys.REPORT, RouteKeys.COUNSELING]);
		const counselingSubmenu = siderRoutes[counselingIndexs[0]]
			.submenu[counselingIndexs[1]]
			.submenu;
		const catInfos = OrgUtil.getAllCategoryInfoFromState(Store.getState());
		const viewByFormat = I18n.t("siderTap.view_by");
		catInfos.forEach(info => {
			counselingSubmenu.push({
				text: viewByFormat.replace("%s",info.name),
				key: this.CreateCategoryRouteKey(info, AttrRouteFormat.COUNSELING),
				menuType: MenuType.ITEM
			});
		});
		siderRoutes[counselingIndexs[0]]
			.submenu[counselingIndexs[1]].submenu = counselingSubmenu;
		return siderRoutes;
	},
	_getRouteIterateIndex(siderRoute, fullRouteKeyPath){
		let readRoute = {submenu:siderRoute};
		const iterateIndexArray = [];
	
		fullRouteKeyPath.forEach(key => {
			if(readRoute.submenu){
				const index = readRoute.submenu.findIndex(r=>r.key === key);
				if(index!==-1){
					readRoute = readRoute.submenu[index];
					iterateIndexArray.push(index);
				}else{
					throw new Error("Cannot find route ",fullRouteKeyPath);
				}
			}else if(readRoute.key === key){
				iterateIndexArray.push(0);
			}
		});

	
		return iterateIndexArray;
	},
	/**
     * Create copy of original SiderRoute
     * @param {object} siderRoute 
     */
	_copySiderRoute(siderRoute){
		if(Array.isArray(siderRoute)){
			return Array.from(siderRoute, v=>this._copySiderRoute(v));
		}
		const copy = {...siderRoute};
		const { submenu } = copy;
		if(submenu!==undefined){
			copy.submenu = this._copySiderRoute(submenu);
		}
		return copy;
	},
};


// WEBPACK FOOTER //
// ./src/util/route.js